import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { CreateSite } from "~pages/Sites/types/upsertSite.ts";
import type { Site, SiteResponse } from "~types/site.ts";

export const useCreateSite = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<Site, Error, CreateSite>({
    mutationFn: async (data) => {
      const response = await request<SiteResponse>(`${sport}/o/${organizationId}/sites`, {
        method: "POST",
        body: data,
      });

      return response?.data?.[0];
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["sites"] }),
        queryClient.invalidateQueries({ queryKey: ["sites", sport, organizationId] }),
      ]);
    },
  });
};
